module.exports = __webpack_public_path__ + "static/media/truckcoin_green.b0d651ad.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/truckcoin_green.svg
// module id = 898
// module chunks = 0